export default __webpack_public_path__ + "5e1cb4b86ac3f872dadcbde3ed31cd4b.svg";